<div class="modal-container" [ngClass]="{'minimized': minimise}">

<!-- STANDARD Modal Header -->
<div class="modal-header">
  <h3 class="modal-title">{{modalTitle}}</h3>
  <div class="header-actions">
    <i class="fa"
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
       style="margin-right: 10px; cursor: pointer;"
       (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<div class="modal-body" [hidden]="minimise">

<!-- Entity Details Display -->
<div style="margin: 5px;">
  <table class="custom-table" style="width: 100%; border: 0px; border-spacing: 0;">
    <tbody>
      <tr>
        <td class="LayerLine1" nowrap>Entity:</td>
        <td class="LayerData1" nowrap>{{entitySelected.LEID}} : {{entitySelected.LE_NAME}} : {{entitySelected.TAX_YEAR_BEGIN}} - {{entitySelected.TAX_YEAR_END}}</td>
        <td class="LayerLine1" nowrap>Reporting Period:</td>
        <td class="LayerData1" nowrap>{{entitySelected.REPORTING_PERIOD}}</td>
        <td class="LayerLine1" nowrap>Business:</td>
        <td class="LayerData1" nowrap>{{entitySelected.ME_CODE}} - {{entitySelected.ME_NAME}}</td>
        <td class="LayerLine1" nowrap>Tax Code:</td>
        <td class="LayerData1" nowrap>{{entitySelected.CDR_NO}}</td>
      </tr>
    </tbody>
  </table>

  <table style="width: 100%; border: 0px; border-spacing: 0;">
    <tbody>
      <tr>
        <td>&nbsp;</td>
      </tr>
      <tr>
        <td style="width: 3px;">
          <i class="fa fa-info-circle" style="font-size:24px;color:skyblue"></i>
        </td>
        <td class="BlackTxtBL">
          Diagnostic: Intercompany Outside own Business - Tax Affiliated Group: For the below referenced DCS Account(s), allocate the amount by Business(es)
        </td>
      </tr>
      <tr>
        <td>&nbsp;</td>
      </tr>
    </tbody>
  </table>
</div>

<!-- Intercompany Outside Account Details -->
<div style="margin: 5px;">
  <table class="table table-bordered form-inline InnerTblBG custom-table">
    @for (row of icoAccountList; track $index) {
<tr [ngClass]="{'header-row': row.ROW_TYPE === 'HEADER'}">
      @if (row.ROW_TYPE === 'HEADER') {

        <th>{{row.ACCOUNT_VALUE}}</th>
        <th>{{row.ACCOUNT_DESC}}</th>
        <th>{{row.NET_AMT}}</th>
      
}
      @if (row.ROW_TYPE === 'DATA_ROW') {

        <td>{{row.ACCOUNT_VALUE}}</td>
        <td>{{row.ACCOUNT_DESC}}</td>
        <td [ngClass]="{'color-red': row.NET_AMT < 0}">{{row.NET_AMT | numberWithCommas}}</td>
      
}
      @if (row.ROW_TYPE === 'TOTAL_ROW') {

        <td style="font-weight: bold;">{{row.ACCOUNT_VALUE}}</td>
        <td>{{row.ACCOUNT_DESC}}</td>
        <td style="font-weight: bold;" [ngClass]="{'color-red': row.NET_AMT < 0}">{{row.NET_AMT | numberWithCommas}}</td>
      
}
    </tr>
}
  </table>
</div>

<!-- Allocate BU Amount Header -->
<div style="margin: 5px;">
  <table class="table table-bordered form-inline InnerTblBG custom-table">
    <tr>
      <th>Allocate BU Amount</th>
    </tr>
  </table>
</div>

<!-- BSLA and Amount Input Section -->
<div>
  <div style="margin: 5px;">
    <div style="display: flex; align-items: center;">
      <div style="width: 25%;"><label>BSLA:</label></div>
      <div style="width: 75%;">
        <select class="form-control"
                [(ngModel)]="selectedBSLA"
                (change)="afterBSLASelected()"
                [disabled]="editMode"
                style="width: 100%;">
          <option value="">Select BSLA</option>
          @for (comp of componentDetails; track $index) {
<option [value]="comp.BSLA_DETAILS">
            {{comp.BSLA_DETAILS}}
          </option>
}
        </select>
      </div>
    </div>
  </div>

  <div style="margin: 5px;">
    <div style="display: flex; align-items: center;">
      <div style="width: 25%;"><label>Amount:</label></div>
      <div style="width: 40%;">
        <input style="text-align: right"
               name="alloc_amount"
               class="form-control"
               [disabled]="editMe"
               [(ngModel)]="allocated_amount"
               type="number">
      </div>
    </div>
  </div>
</div>

<!-- Modal Footer for Submit/Reset/Cancel -->
<div class="modal-footer inline-actions" [hidden]="minimise">
  <button class="save-button"
          type="button"
          (click)="submit()">
    @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}Submit
  </button>
  <button class="reset-button"
          type="button"
          (click)="reset()">Reset</button>
  <button class="cancel-button"
          type="button"
          (click)="cancel()">Cancel</button>
</div>

<!-- CP Form Data Display -->
<div style="margin: 5px;">
  <table class="table table-bordered form-inline InnerTblBG custom-table">
    @for (row of cpFormData; track $index; let mainIndex = $index) {

      <tr>
        @if (row.ROW_TYPE === 'CH') {
<td colspan="10">
          <table class="table table-bordered form-inline InnerTblBG custom-table">
            @for (item of row.Line_data; track $index; let itemIndex = $index) {

              @if (item.Line_Type === 'TABLE_HEADER') {
<tr>
                <td [attr.colspan]="item.colLength">
                  <h5 style="font-weight: bold;" [style.color]="item.Line_color">{{item.Line_Desc}}</h5>
                </td>
              </tr>
}
              @if (item.Line_Type === 'HEADER_ROW') {
<tr>
                @for (column of item.Line_data_occ; track $index) {
<th>
                  <p>{{column.ATTRIB_VALUE}}</p>
                </th>
}
              </tr>
}
              @if (item.Line_Type === 'DATA_ROW' && item.Lock_status === 0) {
<tr>
                <td>
                  <i class="fa fa-pencil bluepencil pull-left"
                     style="cursor: pointer; margin-top: 4px;"
                     title="Edit Details"
                     (click)="editExistingRecord(item.Occurrence, item.Trans_details_key, itemIndex, mainIndex, item.Lock_status)">
                  </i>
                  <i class="fa fa-minus-circle color-red fa-lg pull-right"
                     style="cursor: pointer; margin-top: 4px;"
                     title="Remove Details"
                     (click)="removeExistingRecord(item.Occurrence, item.Trans_details_key, itemIndex, mainIndex)">
                  </i>
                </td>
                @for (column of item.Line_data_occ.slice(1, item.Line_data_occ.length); track $index) {
<td
                    [ngClass]="{'color-red': column.ATTRIB_VALUE < 0}">
                  @if (column.ATTRIB_DESCRIPTION !== 'EDIT' && column.ATTRIB_SHORT_CODE === 'ALLOCATED_BU') {
<p>
                    {{column.DISPLAY_TEXT}}
                  </p>
}
                  @if (column.ATTRIB_DESCRIPTION !== 'EDIT' && column.ATTRIB_SHORT_CODE === 'ALLOCATED_AMT') {
<p>
                    {{column.ATTRIB_VALUE | numberWithCommas}}
                  </p>
}
                </td>
}
              </tr>
}
              @if (item.Line_Type === 'DATA_ROW' && item.Lock_status === 1) {
<tr>
                <td>
                  <i class="fa fa-pencil bluepencil pull-left"
                     style="cursor: pointer; margin-top: 4px;"
                     title="Edit Details"
                     (click)="editExistingRecord(item.Occurrence, item.Trans_details_key, itemIndex, mainIndex, item.Lock_status)">
                  </i>
                </td>
                @for (column of item.Line_data_occ.slice(1, item.Line_data_occ.length); track $index) {
<td
                    [ngClass]="{'color-red': column.ATTRIB_VALUE < 0}">
                  @if (column.ATTRIB_DESCRIPTION !== 'EDIT' && column.ATTRIB_SHORT_CODE === 'ALLOCATED_BU') {
<p>
                    {{column.DISPLAY_TEXT}}
                  </p>
}
                  @if (column.ATTRIB_DESCRIPTION !== 'EDIT' && column.ATTRIB_SHORT_CODE === 'ALLOCATED_AMT') {
<p>
                    {{column.ATTRIB_VALUE | numberWithCommas}}
                  </p>
}
                </td>
}
              </tr>
}
            
}
          </table>
        </td>
}
        @if (row.ROW_TYPE === 'TH') {

          @for (item of row.Line_data; track $index; let i = $index) {
<td style="font-weight: bold;"
              [attr.align]="item.COL_CLASS"
              [attr.colspan]="item.COLSPAN"
              [ngClass]="{'color-red': item.ATTRIB_VALUE < 0}"
             >
            @if (i === 0) {
{{item.ATTRIB_VALUE}}
}
            @if (i !== 0) {
{{item.ATTRIB_VALUE | numberWithCommas}}
}
          </td>
}
        
}
      </tr>
    
}
  </table>
</div>

</div>
<!-- /.modal-body -->

<!-- STANDARD Footer for Save/Cancel -->
<div class="modal-footer" [hidden]="minimise">
  <button class="save-button"
          type="button"
          [disabled]="isSaveClicked"
          (click)="save()">
    @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}Save
  </button>
  <button class="cancel-button"
          type="button"
          (click)="cancel()">Cancel</button>
</div>

</div>
<!-- /.modal-container -->

